// extracted by mini-css-extract-plugin
export default {"button":"NavBackBtn_button__0rj7J","img":"NavBackBtn_img__sr9zb"};